import $ from 'jquery';

// Cookies
function createCookie( name, value, days ) {
	if ( days ) {
		var date = new Date();
		date.setTime( date.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
		var expires = '; expires=' + date.toGMTString();
	} else {
		var expires = '';
	}
	document.cookie = name + '=' + value + expires + '; path=/';
}

function readCookie( name ) {
	var nameEQ = name + '=';
	var ca = document.cookie.split( ';' );
	for ( var i = 0; i < ca.length; i++ ) {
		var c = ca[ i ];
		while ( c.charAt( 0 ) == ' ' ) {
			c = c.substring( 1, c.length );
		}
		if ( c.indexOf( nameEQ ) == 0 ) {
			return c.substring( nameEQ.length, c.length );
		}
	}
	return null;
}

function eraseCookie( name ) {
	createCookie( name, '', -1 );
}

$(function () {
	if ( $( '.js-popup-subscribe' ).length ) {
		var popup = $( '.js-popup-subscribe' );

		if ( readCookie( 'emagazine_subscribed_user' ) == 1 || ! navigator.cookieEnabled ) {
			popup.remove();
		}

		$( '.js-popup-subscribe-close, .js-popup-close' ).on( 'click', function( e ) {
			e.preventDefault();
			popup.fadeOut();
			popup.removeClass( 'c-popup-subscribe--open' );
			eraseCookie( 'emagazine_subscribed_user' );
			createCookie( 'emagazine_subscribed_user', '1' );
		} );

		$( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
			if ( emagazine_script.newsletter_form_id == formId ) {
				popup.fadeOut();
				popup.removeClass( 'c-popup-subscribe--open' );
				eraseCookie( 'emagazine_subscribed_user' );
				createCookie( 'emagazine_subscribed_user', '1', 365 );
			}
		} );

		setTimeout( function() {
			popup.fadeIn();
			popup.addClass( 'c-popup-subscribe--open' );
		}, 30000 );
	}
} );
